<template>
  <div
    class="promote-product"
    :class="[defineSize]"
  >
    <section class="promote-product__content-wrapper">
      <div
        class="promote-product__image-wrapper"
        :class="imageSize"
      >
        <epi-picture
          :image="image"
          :sizes="dimensions"
          :sharpen="80"
          auto-quality="best"
          :use-picture="true"
        />
        <epi-property
          id="Image"
          class="background-edit-button"
          text="Ändra produktbild"
        />
      </div>
      <div class="promote-product__content">
        <h3
          v-if="title || isEditable"
          v-edit="'Title'"
          v-text="title"
        />

        <div class="promote-product__info">
          <p
            v-if="description || isEditable"
            v-edit="'Description'"
          >
            {{ description }}
          </p>
          <p
            v-if="extraInfo || isEditable"
            class="promote-product__info-extra"
          >
            <span>{{ extraInfo }}</span>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "PromoteProductBlock",
  props: {
    blockSize: {
      type: String,
      default: "",
      validator (value) {
        return ["", "full", "half", "third", "quarter"].includes(value)
      }
    },
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    extraInfo: {
      type: String,
      default: ""
    },
    info: {
      type: String,
      default: ""
    },
    image: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      active: false,
      dimensions: {
        small: {
          width: 200
        },
        medium: {
          width: 240
        },
        large: {
          width: 472
        }
      }
    }
  },
  computed: {
    size () {
      return this.isEditable ? "full" : this.blockSize
    },
    defineSize () {
      return this.size.toLowerCase()
    },
    imageSize () {
      if (this.size.toLowerCase() == "full") {
        return "col-12_md-6"
      } else if (this.size.toLowerCase() == "half") {
        return "col-12_md-6_lg-12_xl-6"
      } else {
        return ""
      }
    },
    labelSize () {
      return this.size.toLowerCase() == "full" &&
        this.$root.currentSizeGte("lg")
        ? true
        : false
    }
  }
}
</script>

<style lang="scss">
.promote-product {
  $this: &;

  position: relative;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  border-radius: 0.25rem;
  height: 100%;

  .center--content {
    display: flex;
    align-items: center;
    flex-grow: 1;
  }

  .button--transparent {
    padding-right: 0;
    padding-top: 0;
  }

  &.full {
    @include media-breakpoint-up(xl) {
      max-height: 36.5rem;
    }
  }
  // Content-wrapper

  &__content-wrapper {
    align-items: center;
    padding: 2rem 1rem;
    display: flex;
    flex-grow: 1;
    flex-direction: row;
    background-color: $color-white;
    border-radius: 0.25rem;
    box-shadow: $box-shadow-primary;

    .full &,
    .half & {
      flex-direction: column;
      margin: auto 0;
      justify-content: space-between;
      padding: 1.5rem 3.5rem 2.5rem;
    }

    @include media-breakpoint-up(md) {
      padding: 1.25rem 8rem 1.25rem 3.5rem;

      .full &,
      .half & {
        flex-direction: row;
        padding: 3.25rem 6rem;
      }
    }

    @include media-breakpoint-up(lg) {
      justify-content: space-between;
      padding: 2.5rem 1rem;
      flex-direction: column;

      .third & {
        padding: 2.5rem 1.5rem;
      }

      .half & {
        padding: 2rem 6.5rem 3rem;
        flex-direction: column;
      }

      .full & {
        padding: 5.5rem 5.5rem;
      }
    }

    @include media-breakpoint-up(xl) {
      padding: 2.5rem 2rem;

      .third & {
        padding: 2.5rem 3rem;
      }

      .half & {
        flex-direction: row;
        padding: 8.25rem 3rem;
      }

      .full & {
        padding: 4.5rem 8.5rem;
      }
    }
  }

  // Image wrapper

  &__image-wrapper {
    max-width: 7.375rem;
    min-width: 7.375rem;
    margin-right: 1rem;
    padding: 0;

    .full &,
    .half & {
      max-width: 12.4375rem;
      margin-bottom: 1rem;
      margin-right: 0;
      padding: 0;
    }

    @include media-breakpoint-up(md) {
      max-width: 10rem;
      margin-right: 2rem;

      .full &,
      .half & {
        margin-bottom: 0;
        margin-right: 3.5rem;
        max-width: 15rem;
      }
    }

    @include media-breakpoint-up(lg) {
      margin-bottom: 2.5rem;
      margin-right: 0;

      .third & {
        max-width: 11.5rem;
        margin-right: 0;
      }

      .quarter & {
        max-width: 11.5rem;
        margin-bottom: 3.25rem;
      }

      .half & {
        max-width: 13.0625rem;
        margin-right: 0;
        margin-bottom: 2rem;
      }

      .full & {
        margin-right: 2rem;
        max-width: 25.5rem;
      }
    }

    @include media-breakpoint-up(xl) {
      margin-bottom: 2.5rem;

      .half & {
        max-width: 16rem;
        margin-right: 1rem;
        margin-bottom: 0;
        padding: 1rem;
      }

      .full & {
        margin-right: 4.5rem;
        max-width: 29.5rem;
      }
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    padding-bottom: 0;
    flex-grow: 1;
    text-align: center;

    .third &,
    .quarter & {
      text-align: left;

      @include media-breakpoint-up(md) {
        padding: 0.75rem 0;
        text-align: left;

        .full &,
        .half & {
          padding: 1rem 0;
        }
      }

      @include media-breakpoint-up(lg) {
        text-align: center;

        .button--40 {
          margin: auto auto 0;
        }

        .full &,
        .half & {
          .button--40 {
            margin: 0 auto 0;
          }
        }
      }
    }

    @include media-breakpoint-up(md) {
      max-width: 100%;
    }

    &[class*="col-"] {
      padding-bottom: 0;
    }

    .full & {
      max-width: 100%;
      flex-grow: 1;
    }

    .button--40 {
      width: 100%;
      margin: auto auto 0;

      @include media-breakpoint-up(md) {
        width: fit-content;
      }
    }

    @include media-breakpoint-up(lg) {
      min-height: 13.5rem;

      .half & {
        min-height: 12.5rem;
        margin-right: 1rem;
      }
    }

    h3 {
      font-weight: 500;
      letter-spacing: 0;
      margin: 0;

      @include font(rubrik, 2, "mid");

      .half & {
        @include media-breakpoint-up(md) {
          @include font(rubrik, 4, "mid");
        }

        @include media-breakpoint-up(lg) {
          @include font(rubrik, 3, "mid");
        }
      }

      .full & {
        @include font(rubrik, 3, "mid");

        @include media-breakpoint-up(md) {
          @include font(rubrik, 4, "mid");
        }
      }
    }

    & #{$this}__info {
      margin-bottom: 1rem;

      .full &,
      .half & {
        margin-bottom: 2.5rem;
      }

      @include media-breakpoint-up(md) {
        margin-bottom: 0.75rem;

        .full &,
        .half & {
          margin-bottom: 2rem;
        }
      }

      @include media-breakpoint-up(lg) {
        .full &,
        .half & {
          margin-bottom: 2.5rem;
        }
      }

      p {
        color: $color-secondary-text;
        margin: 0 auto;

        @include font(text, 2, "normal");

        @include media-breakpoint-up(lg) {
          @include font(text, 3, "normal");
        }

        .full & {
          @include media-breakpoint-up(lg) {
            @include font(text, 4, "normal");
          }
        }
      }

      & #{$this}__info-extra {
        @include font(text, 2, "bold");

        padding-top: 5px;
        border-top: 1px solid #ededed;
        margin-top: 1rem;

        .full & {
          @include media-breakpoint-up(lg) {
            @include font(text, 4, "bold");
          }
        }
      }
    }

    @include media-breakpoint-up(lg) {
      .full & {
        .button--40 {
          margin: 0 auto 0;
        }
      }
    }

    @include media-breakpoint-up(xl) {
      .half & {
        .button--40 {
          margin: 0 auto 0;
        }
      }
    }
  }
}
</style>
